import { call, put, takeLatest } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { PayloadAction } from '@reduxjs/toolkit'
import { addToaster, hideLoader, navigateTo, showLoader } from '../slices'
import { v4 as uuid } from 'uuid'
import { saveLayout, updateLayout } from '../slices/layout.slice'
import { SaveLayoutType, updateLayoutType } from '../types'
import { saveLayoutApi, updateLayoutByIdApi } from '../apis'

function* updateLayoutSageFn(
  action: PayloadAction<updateLayoutType>
): SagaIterator {
  yield put(showLoader())
  try {
    const response = yield call(updateLayoutByIdApi, action?.payload)
    if (response.data) {
      yield put(
        addToaster({
          id: uuid(),
          message: 'Layout Updated Successfully !',
          type: 'success',
        })
      )

      yield put(
        navigateTo(
          `/entity-manager/entity/${action?.payload?.layout?.entity_id}/edit-entity/layouts`
        )
      )
    } else {
      addToaster({
        id: uuid(),
        message: 'Something Went Wrong!!',
        type: 'error',
      })
    }
  } catch (err) {
    yield put(
      addToaster({
        id: uuid(),
        message: 'Something Went Wrong!!',
        type: 'error',
      })
    )
  } finally {
    yield put(hideLoader())
  }
}

function* saveLayoutSagaFn(
  action: PayloadAction<SaveLayoutType>
): SagaIterator {
  yield put(showLoader())
  try {
    const response = yield call(saveLayoutApi, action?.payload?.layout)
    if (response.data) {
      yield put(
        addToaster({
          id: uuid(),
          message: 'Layout Updated Successfully !',
          type: 'success',
        })
      )

      yield put(
        navigateTo(
          `/entity-manager/entity/${action?.payload?.layout?.entity_id}/edit-entity/layouts`
        )
      )
    } else {
      addToaster({
        id: uuid(),
        message: 'Something Went Wrong!!',
        type: 'error',
      })
    }
  } catch (err) {
    yield put(
      addToaster({
        id: uuid(),
        message: 'Something Went Wrong!!',
        type: 'error',
      })
    )
  }
  yield put(hideLoader())
}

export function* watchUpdateLayout() {
  yield takeLatest(updateLayout.type, updateLayoutSageFn)
}

export function* watchSaveLayout() {
  yield takeLatest(saveLayout.type, saveLayoutSagaFn)
}
